var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcpNoCircleDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 43 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1-gcp-no-circle-disabled",
    points: "0.578040902 0.923125 27.3305702 0.923125 27.3305702 12.7428437 0.578040902 12.7428437"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3-gcp-no-circle-disabled",
    points: "0.936630977 0.56875 22.966412 0.56875 22.966412 29.53125 0.936630977 29.53125"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GCP-Logo--disable",
    transform: "translate(0.000000, -1.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GCP-Logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(4.499248, 0.170625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-1-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1-gcp-no-circle-disabled"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path-3-gcp-no-circle-disabled"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2081762,10.0051875 L23.4927116,10.0051875 L27.1506003,6.44284375 L27.3305702,4.9301875 C20.5209582,-0.921375 10.1299447,-0.291375 4.12007399,6.3389375 C2.44972812,8.18190625 1.23943038,10.3715937 0.578040902,12.7428437 C0.985222857,12.579875 1.43739729,12.5547187 1.86257624,12.6684687 L9.17947849,11.4926875 C9.17947849,11.4926875 9.55179128,10.8933125 9.74300932,10.9305 C12.9982154,7.4501875 18.4760499,7.04440625 22.2340469,10.0051875 L22.2081762,10.0051875 Z",
    id: "Fill-1",
    fill: "#A7A7A7",
    fillRule: "nonzero",
    mask: "url(#mask-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(19.121804, 4.545625)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill-4-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3-gcp-no-circle-disabled"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.7390731,8.36828125 C16.8977137,5.35171875 15.172252,2.6425 12.7707784,0.56875 L7.63713624,5.56828125 C9.80464902,7.293125 11.0396926,9.891875 10.9868265,12.6185937 L10.9868265,13.505625 C13.5120295,13.505625 15.5569377,15.4984375 15.5569377,17.9539062 C15.5569377,20.4126562 13.5120295,22.4054687 10.9868265,22.4054687 L1.84772872,22.4054687 L0.936630977,23.305625 L0.936630977,28.6442187 L1.84772872,29.53125 L10.9868265,29.53125 C17.5512295,29.579375 22.9154581,24.43875 22.9660746,18.0457812 C22.9975694,14.1717187 21.0358971,10.5382812 17.7390731,8.36828125",
    id: "Fill-4",
    fill: "#A7A7A7",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M11.8168253,34.0268906 L20.955923,34.0268906 L20.955923,26.9011094 L11.8168253,26.9011094 C11.1655591,26.9011094 10.5221666,26.7632969 9.92939068,26.5007969 L8.64598015,26.8890781 L4.96222075,30.4514219 L4.64164932,31.7015781 C6.70792902,33.2197031 9.22750797,34.0378281 11.8168253,34.0268906",
    id: "Fill-7",
    fill: "#A7A7A7",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8168253,10.9137472 C5.25242226,10.9510625 -0.0386935339,16.1649687 0.000674887218,22.5579375 C0.0220463158,26.1279375 1.73513503,29.48575 4.64164932,31.6645 L9.94176361,26.5009062 C7.64264782,25.4891875 6.62019369,22.8543437 7.66064482,20.61325 C8.69884631,18.3743437 11.4062689,17.3790313 13.7065095,18.3896562 C14.7188403,18.837 15.5320795,19.6277812 15.9887531,20.61325 L21.2899922,15.45075 C19.0347441,12.5796562 15.5287049,10.9018437 11.8168253,10.9137472",
    id: "Fill-9",
    fill: "#A7A7A7",
    fillRule: "nonzero"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcpNoCircleDisabled);
export default __webpack_public_path__ + "static/media/gcp-no-circle-disabled.e62af9df1242dab8ab6db522d67d4560.svg";
export { ForwardRef as ReactComponent };